import React, { useState, useEffect } from "react";
import { useAuth } from "../hooks/useAuth";
import { Navigate } from "react-router-dom";
import { useSearchParams } from "react-router-dom";
import { useDialog } from '../components/Modal/DialogContext';
import { useNavigate } from "react-router-dom";


const VerifyEmail: React.FC = () => {
  const { user, resetPassword } = useAuth();

  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState("");



  const dialog = useDialog();
  const navigate = useNavigate();

useEffect(() => {
  const token = searchParams.get("token");
  if (!token) {
    setError("Kein Token übergeben.");
    return;
  }

  const verify = async () => {
    try {
      const res = await fetch("/auth/api/verify-email/?token=" + token);
      if (!res.ok) throw new Error("Token ungültig oder abgelaufen");
      setSuccess(true);
    } catch (err: any) {
      setError(err.message || "Etwas ist schiefgelaufen");
    }
  };

  verify();
}, [searchParams]);

// handle dialog + redirect for success
useEffect(() => {
  if (success) {
    const handleConfirm = () => {
      navigate("/login");

    };

    dialog({
      type: 'alert',
      title: 'Geschafft!',
      message: 'Ihre E-Mail-Adresse wurde bestätigt. Sie werden nun zum Login weitergeleitet.',
      confirmButton: 'OK',
      onConfirm: handleConfirm
    });
  }
}, [success]);

// handle dialog for error
useEffect(() => {
  if (error) {
    const handleConfirm = () => {
      navigate("/login");
    };

    dialog({
      type: 'alert',
      title: 'Fehler',
      message: 'Bitte überprüfen Sie Ihre Daten und versuchen Sie es erneut. Sollte das Problem weiterhin bestehen, wenden Sie sich bitte an unseren Support.',
      confirmButton: 'OK',
      onConfirm: handleConfirm
    });
  }
}, [success]);


return null;

};

export default VerifyEmail;